<template>
  <div class="d-flex flex-row">
    <div class="py-2">{{ index + 1 }}.</div>
    <div class="flex-grow-1 mx-3">
      <FormFieldEditor :field="field" :form="form" :editing="editing"/>
    </div>
    <div class="d-flex flex-row align-items-start gap-1">
      <button type="button" class="btn btn-icon btn-flat" @click="editing = !editing">
        <i class="bi-pencil" />
      </button>
      <button
        type="button"
        ref="moveButton"
        class="btn btn-flat dropdown-toggle no-caret"
        data-bs-toggle="dropdown"
        title="Move to..."
      >
        <i class="bi-chevron-expand" />
      </button>
      <ul class="dropdown-menu position-fixed">
        <li v-for="(field, i) in form.fields" :key="`${field.id}_${i}`">
          <button type="button" @click="moveTo(i)" class="dropdown-item" :disabled="i === index">
            Move to position {{ i + 1 }}
          </button>
        </li>
      </ul>
      <button type="button" class="btn btn-icon btn-flat" @click="remove">
        <i class="bi-trash"/>
      </button>
    </div>
  </div>
</template>

<script>
import FormField from "@/models/FormField";
import {LicenseApplicationForm} from "@/models/LicenseApplicationForm";
import FormFieldEditor from "@/components/common/FormFieldEditor.vue";

export default {
  components: {FormFieldEditor},
  props: {
    field: FormField,
    form: LicenseApplicationForm
  },
  data() {
    return {
      editing: false
    };
  },
  computed: {
    index() {
      return this.form.fields.findIndex(field => field.id === this.field.id);
    }
  },
  methods: {
    remove() {
      this.form.removeField(this.field.id);
    },
    moveTo(index) {
      this.form.moveField(this.field.id, null, index);
    },
    edit() {
      this.editing = true;
    }
  }
}
</script>
